import { EmployeeRolesEnum, ErrorResponse, StatusEnum, TypeOfStock, UnitRequest } from '@gtpl/shared-models/common-models';
import { CommonResponse, ItemCategoryReq, ItemRequest } from '@gtpl/shared-models/masters';
import { AllStoreReturnsResponseModel, ConsumedQtyRequest, StoreConsumptionStatus, StoreReturnResponseModel } from '@gtpl/shared-models/procurement-management';
import { ItemCategoryService, ItemsService, UnitcodeService } from '@gtpl/shared-services/masters';
import { SaleOrderService, saleOrder } from '@gtpl/shared-services/sale-management';
import { Body, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { StoreReturnInformation } from '@gtpl/shared-models/procurement-management';
import { getConnection, getManager, Repository } from 'typeorm';
import { Stock } from '../stock/stock.entity';
import { StoreConsumptionItems } from '../store-consumption/entity/store-consumption-items.entity';
import { StoreReturnDTO } from './dto/store-return-dto';
import { StoreReturnAdapter } from './dto/store-return.adapter';
import { StoreReturnRequest } from './dto/store-return.request';
import { StoreReturn } from './store-return.entity';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { StoreConsumption } from '../store-consumption/entity/store-consumption.entity';
import { UnitIdRequest } from '../store-consumption/dto/unit-id.request';
import appSettings from 'apps/services/config';
import { StockRepository } from '../grn/repository/stock-repository';
import { ReturnReq } from '../store-consumption/dto/store-return-req';

@Injectable()
export class StoreReturnsService {
  constructor(
    @InjectRepository(StoreReturn)
    private storeReturnRepository: Repository<StoreReturn>,
    private storeReturnAdapter: StoreReturnAdapter,
    private soService: SaleOrderService,
    private CategoryService: ItemCategoryService,
    private itemService: ItemsService,
    private unitcodeService: UnitcodeService
  ) { }

  async createStoreReturn(storeReturnDTO: StoreReturnDTO, isUpdate: boolean, request: Request): Promise<StoreReturnResponseModel> {
    const manager = new GenericTransactionManager();
    try {
      const managerQuery = getManager();
      const storeReturnInfo = `SELECT so.status as status from ` + appSettings.sales_db + `.sale_order so where sale_order_id = ${storeReturnDTO.saleOrderId} and status='${StatusEnum.CANCELLED}'`;

      const data = await managerQuery.query(storeReturnInfo);
      console.log(data);

      const sOContainerStatus = `SELECT sot.container_status as containerStatus from ` + appSettings.sales_db + `.sale_order_track sot where sale_order_id = ${storeReturnDTO.saleOrderId}`;

      const containerResponse = await managerQuery.query(sOContainerStatus);
      console.log(containerResponse);

      const today = new Date();
      const CurrentYear = today.getFullYear();

      const totalStoreReturns = await this.storeReturnRepository.count({ where: { unitId: storeReturnDTO.unitId } });

      // get form plant name 
      const plantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: storeReturnDTO.unitId });
      const fromPlant = plantDetails.status ? plantDetails.data.unitcodeName : "";

      const currentFinancialYear = "STRRTN/" + fromPlant + "/" + (CurrentYear.toString().substr(-2)) + "/" + (totalStoreReturns + 1);

      const convertedStoreReturnEntity: StoreReturn = this.storeReturnAdapter.convertDtoToEntity(storeReturnDTO, isUpdate, currentFinancialYear);

      await manager.startTransaction();
      const savedStoreReturnEntity: StoreReturn = await manager.getRepository(StoreReturn).save(
        convertedStoreReturnEntity
      );
      let type = storeReturnDTO.isDamaged ? TypeOfStock.DAMAGED : TypeOfStock.GOOD

      if (savedStoreReturnEntity) {
        if (data?.length > 0 || containerResponse?.length > 0) {
          console.log("Cancelled");
          const existed = `SELECT s.stock_id as stockId from ` + appSettings.procure_db + `.stock s where saleOrder_id = 0 and item_id='${storeReturnDTO.itemId}' and s.location_id = ${storeReturnDTO.locationId} and s.type = ${type}`;

          let alreadyExist = await managerQuery.query(existed);
          // move stock to inventory
          // const alreadyExist = await this.stockRepository.findOne({ where: { saleOrderId: 0, itemCategoryId: storeReturnDTO.itemCategoryId, itemId: storeReturnDTO.itemId } })
          console.log(alreadyExist);
          console.log("alreadyExist");
          const stockEntity = new Stock();
          stockEntity.saleOrderId = 0;
          stockEntity.itemId = storeReturnDTO.itemId;
          stockEntity.unitId = storeReturnDTO.unitId;
          stockEntity.locationId = storeReturnDTO.locationId;
          stockEntity.itemCategoryId = storeReturnDTO.itemCategoryId;
          stockEntity.sizeId = 0;
          stockEntity.physicalQuantity = savedStoreReturnEntity.returnQuantity;
          stockEntity.unitPrice = 0;
          stockEntity.createdUser = storeReturnDTO.createdUser;
          stockEntity.type = type;
          let savedStockEntity;
          if (alreadyExist?.length > 0) {
            alreadyExist = alreadyExist.find((data) => data.stockId);
            stockEntity.stockId = alreadyExist.stockId;
            savedStockEntity = await manager.getCustomRepository(StockRepository).update({ stockId: alreadyExist.stockId }, { physicalQuantity: () => `physical_quantity+${savedStoreReturnEntity.returnQuantity}` });
          } else {
            console.log("Create Stock");
            savedStockEntity = await manager.getCustomRepository(StockRepository).save(stockEntity);
          }
        } else {
          console.log("Update Stock");
          // update Stock
          const findIfStockExist = await manager.getRepository(Stock).find()
          const updateStock = await manager.getRepository(Stock).update(
            {
              saleOrderId: storeReturnDTO.saleOrderId, itemId: storeReturnDTO.itemId, unitId: storeReturnDTO.unitId, locationId: storeReturnDTO.locationId
            }, {
            physicalQuantity: () => `physical_quantity+${savedStoreReturnEntity.returnQuantity}`
          }
          );
          if (!updateStock.affected) {
            throw new ErrorResponse(1111, 'Failed to Update Stock');
          }
        }


        /* -- stock update logic --
        - if so_status is cancelled 
            - update returned stock to BULK (ie where sale_order_id = 0)
                - check if stock record exists with returned item_id and location_id = 0 
                      -if stock exists update quantity at that record else create new record
        - if so_status is not cancelled 
            - update returned stock to that so_id
                - check if stock record exists with so_id,item_id,location_id = 0
                      - if if stock exists update quantity at that record else create new record */
        



        // if ((storeReturnDTO.storeConsumptionId?.length) > 0) {

        // let returnedQty = savedStoreReturnEntity.returnQuantity;
        // console.log(returnedQty);
        // console.log("returnedQty");
        // for (const val of storeReturnDTO.storeConsumptionId) {
        // data
        // // check the consumed Qty
        // const consumedQty = await manager.getRepository(StoreConsumptionItems).findOne({ where: { storeConsumptionId: val, itemId: storeReturnDTO.itemId } });
        // if (consumedQty) {
        //   console.log(consumedQty);
        //   console.log("consumedQty");
        //   let status: StoreConsumptionStatus = StoreConsumptionStatus.Open;
        //   const remainingQty = consumedQty.quantity - consumedQty.returnedQuantity;


        //   if (remainingQty > returnedQty) {
        //     status = StoreConsumptionStatus.Partially_Returned;
        //   } else {
        //     status = StoreConsumptionStatus.Returned;
        //   }
        //   returnedQty -= remainingQty;
        //   console.log(returnedQty);
        //   console.log("returnedQty");
        //   // check the returned qty
        //   const updateStoreConsumptionItem = await manager.getRepository(StoreConsumptionItems).update(
        //     {
        //       storeConsumptionId: val, itemId: storeReturnDTO.itemId
        //     }, {
        //     returnedQuantity: () => `returned_quantity+${remainingQty}`, status: status
        //   }
        //   );

        //   if (!updateStoreConsumptionItem.affected) {
        //     throw new ErrorResponse(1111, 'Failed to Update Store Consumption Item');
        //   }

        //   // update Store consumption status
        //   const updateStoreConsumption = await manager.getRepository(StoreConsumption).update(
        //     {
        //       storeConsumptionId: val
        //     }, {
        //     status: status
        //   }
        //   );

        //   if (!updateStoreConsumption.affected) {
        //     throw new ErrorResponse(1111, 'Failed to Update Store Consumption');
        //   }
        // }

        // }

        // }


        // get item category details for item category id
        const itemCategoryReq = new ItemCategoryReq(savedStoreReturnEntity.itemCategoryId);
        const itemCategoryDetails = this.CategoryService.getItemCategoryById(itemCategoryReq);
        if (!itemCategoryDetails) {
          throw new ErrorResponse(1111, 'Failed to Get Item Category');
        }
        // // get item details for item id 
        const itemReq = new ItemRequest(savedStoreReturnEntity.itemId);
        const itemDetails = this.itemService.getItemById(itemReq);
        if (!itemDetails) {
          throw new ErrorResponse(1111, 'Failed to Get Item');
        }

        let item;
        await Promise.all([itemCategoryDetails, itemDetails]).then(res => {
          item = new StoreReturnInformation(savedStoreReturnEntity.storeReturnId, savedStoreReturnEntity.storeReturnDate, null, (res[0]) ? res[0] : null, (res[1]) ? res[1] : null, savedStoreReturnEntity.storeReturnNo, savedStoreReturnEntity.returnQuantity, savedStoreReturnEntity.remarks, savedStoreReturnEntity.unitId);
        })

        // generating resposnse
        manager.completeTransaction();
        const response = new StoreReturnResponseModel(true, isUpdate ? 11101 : 11100, isUpdate ? 'Store Return Updated Successfully' : 'Store Return Created Successfully', item);
        return response;
      } else {
        throw new ErrorResponse(11106, 'Store Return saved but issue while transforming into DTO');
      }
    } catch (error) {
      await manager.releaseTransaction();
      return error;
    }
  }

  async getAllStoreReturns(req: UnitIdRequest): Promise<AllStoreReturnsResponseModel> {
    console.log(req,"were")
    try {
      const manager = getManager();
      let storeReturnInfo = `SELECT store_return_id as storeReturnId,strn.item_category_id as itemCategoryId, store_return_date as storeReturnDate, so.sale_order_no as saleOrderNo, i.item_name as itemName, store_return_no as storeReturnNo, return_quantity as returnQuantity, strn.remarks, uc.unit_name as unitId, inv.po_number as poNumber, so.status as status, inv.category, CONCAT(so.sale_order_no," - ", inv.po_number) AS saleOrder from ` + appSettings.procure_db + `.store_return strn 
      left join ` + appSettings.sales_db + `.sale_order so on strn.sale_order_id =so.sale_order_id  
      LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=so.sale_order_id 
      left join ` + appSettings.masters_db + `.items i on i.item_id = strn.item_id
      left join ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = strn.unit_id `;

      // if ((([
      //   EmployeeRolesEnum.ADMIN
      // ].indexOf(req.role)) === -1) && req.itemCategoryId) {
      //   storeReturnInfo += ` where strn.unit_id= ${req.unitId} and strn.item_category_id = ${req.itemCategoryId} `;
      // }
      if (([EmployeeRolesEnum.ADMIN].indexOf(req.role) === -1) && req.itemCategoryId) {
        storeReturnInfo += ` WHERE strn.unit_id = ${req.unitId} AND strn.item_category_id = ${req.itemCategoryId} `;
    }

      // if (req.unitId && req.unitId != 5) {
      //   storeReturnInfo += `and strn.unit_id= ${req.unitId}` 
      // }

      if (req.unitId && req.unitId != 5) {
        // Use "AND" only if the previous condition was applied
        storeReturnInfo += (storeReturnInfo.includes('WHERE') ? ' AND ' : ' WHERE ') + `strn.unit_id = ${req.unitId}`;
    }

      // if (req.itemCategoryId && req.unitId != 5) {
      //   storeReturnInfo += `and strn.item_category_id = ${req.itemCategoryId}` 
      // }

      if (req.itemCategoryId && req.unitId != 5) {
        // Use "AND" only if the previous condition was applied
        storeReturnInfo += (storeReturnInfo.includes('WHERE') ? ' AND ' : ' WHERE ') + `strn.item_category_id = ${req.itemCategoryId}`;
    }
      const storeReturnDTO = await manager.query(storeReturnInfo);



      // const storeReturnDTO: StoreReturnInformation[] = [];
      // const storeReturnsEntities: StoreReturn[] = await this.storeReturnRepository.find({
      //   where: { unitId: req.unitId },
      //   order: { 'storeReturnId': 'DESC' }
      // });


      if (storeReturnDTO && storeReturnDTO.length) {
        // for (const storeReturnEntity of storeReturnsEntities) {
        //   const soReq: saleOrder = {
        //     saleOrderId: storeReturnEntity.saleOrderId
        //   }

        //   const saleOrderDetails = await this.soService.getSaleOrderFewDetailsForSoId(soReq);

        //   if (!saleOrderDetails) {
        //     throw new ErrorResponse(1111, 'Failed to Get Sale Order');
        //   }

        //   // get item category details for item category id
        //   const itemCategoryReq = new ItemCategoryReq(storeReturnEntity.itemCategoryId);
        //   const itemCategoryDetails = this.CategoryService.getItemCategoryById(itemCategoryReq);
        //   if (!itemCategoryDetails) {
        //     throw new ErrorResponse(1111, 'Failed to Get Item Category');
        //   }
        //   // // get item details for item id 
        //   const itemReq = new ItemRequest(storeReturnEntity.itemId);
        //   const itemDetails = this.itemService.getItemById(itemReq);
        //   if (!itemDetails) {
        //     throw new ErrorResponse(1111, 'Failed to Get Item');
        //   }

        //   await Promise.all([itemCategoryDetails, itemDetails]).then(res => {
        //     const item = new StoreReturnInformation(storeReturnEntity.storeReturnId, storeReturnEntity.storeReturnDate, saleOrderDetails, (res[0]) ? res[0] : null, (res[1]) ? res[1] : null, storeReturnEntity.storeReturnNo, storeReturnEntity.returnQuantity, storeReturnEntity.remarks, storeReturnEntity.unitId);
        //     storeReturnDTO.push(item);
        //   })
        // }

        const response = new AllStoreReturnsResponseModel(true, 11108, "Store Returns retrieved successfully",storeReturnDTO);
         return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }

  async getAllStoreReturnsReports(req: ReturnReq): Promise<AllStoreReturnsResponseModel> {
    try {
      const manager = getManager();
      let storeReturnInfo = `SELECT store_return_id as storeReturnId, store_return_date as storeReturnDate, so.sale_order_no as saleOrderNo, i.item_name as itemName, store_return_no as storeReturnNo, return_quantity as returnQuantity, strn.remarks, uc.unit_name as unitId, inv.po_number as poNumber, so.status as status, inv.category, CONCAT(so.sale_order_no," - ", inv.po_number) AS saleOrder,sc.store_consumption_code as storeConsumptionCode,r.reasons_name as returnReasion,strn.approvar as approvar,i.packing_category as itemCtegory,i.item_sub_category_id as itemSubCategoryId ,strn.remarks as remarks,strn.created_at as createdDate from ` + appSettings.procure_db + `.store_return strn 
      left join ` + appSettings.sales_db + `.sale_order so on strn.sale_order_id =so.sale_order_id  
      LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=so.sale_order_id 
      left join ` + appSettings.masters_db + `.items i on i.item_id = strn.item_id
      left join ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = strn.unit_id 
      left join ` + appSettings.procure_db + `.store_consumption sc on sc.sale_order_id =strn.sale_order_id
      left join ` + appSettings.masters_db + `.reasons r on r.reasons_id = strn.store_return_id where strn.store_return_id > 0 `;

      if (req.unitId && req.unitId != 5) {
        storeReturnInfo += ` and strn.unit_id = ` + req.unitId
      }
      if (req.poNumber) {
        storeReturnInfo = storeReturnInfo + ' and strn.sale_order_id = ' + req.poNumber
      }
      if (req.selectedCreatedFromDate != undefined) {
        storeReturnInfo = storeReturnInfo + ' and date(strn.created_at) >= "' + req.selectedCreatedFromDate + '" and  date(strn.created_at) <= "' + req.selectedCreatedToDate + '"';
      }
      if (req.itemSubCategoryId) {
        storeReturnInfo = storeReturnInfo + ' and i.item_sub_category_id = "' + req.itemSubCategoryId + '"';
      }
      if (req.itemId) {
        storeReturnInfo = storeReturnInfo + ' and i.item_id = ' + req.itemId;
      }
      const storeReturnDTO = await manager.query(storeReturnInfo);

      if (storeReturnDTO && storeReturnDTO.length) {

        const response = new AllStoreReturnsResponseModel(true, 12108, "Store Returns retrieved successfully", storeReturnDTO);
        return response;
      } else {
        throw new AllStoreReturnsResponseModel(false, 99928, 'Data not found', storeReturnDTO);
      }
    } catch (err) {
      return err;
    }
  }

  async getStoreReturnById(storeReturnRequest: StoreReturnRequest): Promise<any> {
    try {
      const storeReturnEntities: StoreReturn = await this.storeReturnRepository.findOne({
        where: { storeReturnId: storeReturnRequest.storeReturnId }
      });
      // const storeReturnsData: StoreReturnDTO = this.storeReturnAdapter.convertEntityToDto(storeReturnEntities);

      if (storeReturnEntities) {
        const soReq: saleOrder = {
          saleOrderId: storeReturnEntities.saleOrderId
        }

        const saleOrderDetails = await this.soService.getSaleOrderFewDetailsForSoId(soReq);
        if (!saleOrderDetails) {
          throw new ErrorResponse(1111, 'Failed to Get Sale Order');
        }

        // get item category details for item category id
        const itemCategoryReq = new ItemCategoryReq(storeReturnEntities.itemCategoryId);
        const itemCategoryDetails = this.CategoryService.getItemCategoryById(itemCategoryReq);
        if (!itemCategoryDetails) {
          throw new ErrorResponse(1111, 'Failed to Get Item Category');
        }
        // // get item details for item id 
        const itemReq = new ItemRequest(storeReturnEntities.itemId);
        const itemDetails = this.itemService.getItemById(itemReq);
        if (!itemDetails) {
          throw new ErrorResponse(1111, 'Failed to Get Item');
        }
        let strRtnItem;
        await Promise.all([itemCategoryDetails, itemDetails]).then(res => {
          strRtnItem = new StoreReturnInformation(storeReturnEntities.storeReturnId, storeReturnEntities.storeReturnDate, saleOrderDetails, (res[0]) ? res[0] : null, (res[1]) ? res[1] : null, storeReturnEntities.storeReturnNo, storeReturnEntities.returnQuantity, storeReturnEntities.remarks, storeReturnEntities.unitId);
        })
        const response = new StoreReturnResponseModel(true, 11101, 'Store Return retrived Successfully', strRtnItem);
        return response;
      }
      else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async getReturnedQty(req: ConsumedQtyRequest) {
    try {
      // if (req.saleOrderId && req.storeConsumptionId && req.itemId) {
      //   response = await this.storeReturnRepository.createQueryBuilder('store_return')
      //     .select('sum(return_quantity) as qty')
      //     .where(`store_return.store_consumption_id IN ( ` + req.storeConsumptionId + `) and store_return.sale_order_id = ` + req.saleOrderId + ` and item_id =` + req.itemId + ` and unit_id=` + req.unitId)
      //     .groupBy('item_id')
      //     .getRawOne();
      // } else {
      const response = await this.storeReturnRepository.createQueryBuilder('store_return')
        .select('sum(return_quantity) as qty')
        .where(`sale_order_id = ` + req.saleOrderId + ` and item_id =` + req.itemId + ` and unit_id=` + req.unitId)
        .groupBy('item_id')
        .getRawOne();
      // }
      if (response) {
        return response.qty;
      } else {
        return 0;
      }
    } catch (error) {
      return error;
    }
  }

  async getSoDropForStoreReturnReport(req: UnitRequest): Promise<CommonResponse> {
    const manager = getManager()
    let query = `SELECT sr.sale_order_id as saleOrderId,si.po_number as poNumber , sr.unit_id from ` + appSettings.procure_db + `.store_return sr 
     left join ` + appSettings.sales_db + `.so_invoice_details si on  si.sale_order_id = sr.sale_order_id 
     WHERE sr.sale_order_id> 0` ;
    if (req.unitId && req.unitId != 5) {
      query = query + ' and sr.unit_id = ' + req.unitId;
    }
    query = query + ` GROUP BY sr.sale_order_id  ORDER BY poNumber `;
    const data = await manager.query(query);
    if (data) {
      return new CommonResponse(true, 1111, 'Data retreived sucessfully', data)
    } else {
      return new CommonResponse(false, 1111, 'No data')
    }
  }
  async getItemSubDropForStoreReturnReport(req: UnitRequest): Promise<CommonResponse> {
    const manager = getManager()
    let query = `SELECT i.item_sub_category_id AS itemSubCategoryId , i.packing_category AS itemCtegory , strn.unit_id from ` + appSettings.procure_db + `.store_return strn 
    left join ` + appSettings.masters_db + `.items i on i.item_id = strn.item_id 
    WHERE i.item_sub_category_id> 0` ;
    if (req.unitId && req.unitId != 5) {
      query = query + ' and strn.unit_id = ' + req.unitId;
    }
    query = query + ` GROUP BY i.item_sub_category_id  ORDER BY itemCtegory `;
    const data = await manager.query(query);
    if (data) {
      return new CommonResponse(true, 1141, 'Data retrieved successfully', data)
    } else {
      return new CommonResponse(false, 1141, 'No data')
    }
  }
  async getItemDropForStoreReturnReport(req: UnitRequest): Promise<CommonResponse> {
    const manager = getManager()
    let query = `SELECT i.item_id AS itemId , i.item_name AS itemName , strn.unit_id from ` + appSettings.procure_db + `.store_return strn 
  left join ` + appSettings.masters_db + `.items i on i.item_id = strn.item_id 
  WHERE i.item_id > 0 ` ;
    if (req.unitId && req.unitId != 5) {
      query = query + ' and strn.unit_id = ' + req.unitId;
    }
    query = query + ` GROUP BY i.item_id  ORDER BY itemName `;
    const data = await manager.query(query);
    if (data) {
      return new CommonResponse(true, 1141, 'Data retrieved successfully', data)
    } else {
      return new CommonResponse(false, 1141, 'No data')
    }
  }

  async createStoreReturnForV2(req:StoreReturnDTO):Promise<CommonResponse>{
    const transactionManager = new GenericTransactionManager()
    try{
      await transactionManager.startTransaction()
      const findStockRecord = await transactionManager.getRepository(Stock).find({where:{itemId:req.itemId,unitId:req.unitId,saleOrderId:0,locationId:req.locationId}})
      if(findStockRecord.length > 0){
        const updateStock = await transactionManager.getRepository(Stock).update({stockId:findStockRecord[0].stockId},{physicalQuantity:Number(findStockRecord[0].physicalQuantity)+ Number(req.returnQuantity)})
        if(!updateStock.affected){
          await transactionManager.releaseTransaction()
          return  new CommonResponse(false,0,'Somethign went wrong in updating stock')
        }
      }else{
        const stockObj = new Stock()
        stockObj.itemId = req.itemId
        stockObj.itemCategoryId = req.itemCategoryId
        stockObj.itemSubCategoryId = req.itemSubCategory
        stockObj.locationId = req.locationId
        stockObj.physicalQuantity = req.returnQuantity
        stockObj.saleOrderId = 0
        stockObj.unitId = req.unitId
        stockObj.type = req.isDamaged ? TypeOfStock.DAMAGED : TypeOfStock.GOOD
        stockObj.createdUser = req.createdUser
        stockObj.unitPrice = 0

        const saveStock = await transactionManager.getRepository(Stock).save(stockObj)
        if(!saveStock){
          await transactionManager.releaseTransaction()
          return  new CommonResponse(false,0,'Somethign went wrong in updating stock')
        }
      }

      const today = new Date();
      const CurrentYear = today.getFullYear();

      const totalStoreReturns = await this.storeReturnRepository.count({ where: { unitId: req.unitId } });

      // get form plant name 
      const plantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: req.unitId });
      const fromPlant = plantDetails.status ? plantDetails.data.unitcodeName : "";

      const storeReturnNum = "STRRTN/" + fromPlant + "/" + (CurrentYear.toString().substr(-2)) + "/" + (totalStoreReturns + 1);
      const storeReturnObj = new StoreReturn()
      storeReturnObj.storeReturnDate = new Date()
      storeReturnObj.saleOrderId = 0
      storeReturnObj.itemCategoryId = req.itemCategoryId
      storeReturnObj.itemId = req.itemId
      storeReturnObj.storeReturnNo = storeReturnNum
      storeReturnObj.isDamaged = req.isDamaged ? 1 : 0
      storeReturnObj.returnReason = req.returnReason
      storeReturnObj.returnQuantity = req.returnQuantity
      storeReturnObj.unitId = req.unitId
      storeReturnObj.remarks = req.remarks
      storeReturnObj.approvar = req.approvar

      const saveStoreReturn = await transactionManager.getRepository(StoreReturn).save(storeReturnObj)

      if(saveStoreReturn){
        await transactionManager.completeTransaction()
        return new CommonResponse(true,1,'Updated successfully')
      }else{
        await transactionManager.releaseTransaction()
        return new CommonResponse(false,0,'Somethign went wrong in saving store return info')
      }
    }catch(err){
      await transactionManager.releaseTransaction()
      return new CommonResponse(false,0,'Somethign went wrong')
    }
  }
}
